// actions/pubsub/disable.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

export function disableHasErrored(bool) {
  return {
    type: 'DISABLE_HAS_ERRORED',
    hasErrored: bool
  };
}

export function disableIsLoading(bool) {
  return {
    type: 'DISABLE_IS_LOADING',
    isLoading: bool
  };
}

export function disableFetchDataSuccess(response) {
  return {
    type: 'DISABLE_FETCH_DATA_SUCCESS',
    response
  };
}

export function disableFetchData(host, params) {
  return (dispatch) => {
    dispatch(disableIsLoading(true));
    dispatch(disableHasErrored(false));
    fetch(host + 'admin/disable', {
      method: 'post',
      body: JSON.stringify(params),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(disableFetchDataSuccess(result));
            PubSub.publish('pubsub.list.reload', true);
          })
          .catch(() => dispatch(disableHasErrored(true)));
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(disableHasErrored(true));
      dispatch(disableIsLoading(false));
    });
  };
}